import React from 'react'
import styled from 'styled-components'
import { QuestionnaireFormLabel } from 'spa/member/components/QuestionnaireFormLabel'
import { Select } from 'spa/member/components/Select'
import { OptionType } from 'spa/member/components/Select/styled'


export type Props = {
  name: string,
  label: string | React.ReactNode,
  annotationNote?: string,
  required?: boolean,
  options: OptionType[],
  rules?: any
  onChange?: (e: React.ChangeEvent<HTMLSelectElement>) => void,
  dataCy?: string,
}

const StyledFormContainer = styled.div`
  width: 100%;
`

export const StyledSelectForm: React.FC<Props> = (props: Props) => {
  return (
    <StyledFormContainer data-cy={props.dataCy}>
      <QuestionnaireFormLabel htmlFor={props.name} label={props.label} required={props.required}  annotationNote={props.annotationNote} />
      <Select id={props.name} name={props.name} options={props.options} rules={props.rules} onChange={props.onChange} />
    </StyledFormContainer>
  )
}
